export enum RespondentStatuses {
  notStarted = 0,
  added = 10,
  invited = 20,
  started = 30,
  completedSurveyQ75 = 40,
  completedSurveyStaticValue = 50,
  completedSurvey = 60,
  declined = 70
}
